import { UserDto } from "@/types/dto/user-dto";
import { atom } from "recoil";
import { initPage } from "../../common/constant/init-page";
import { BasePageDto } from "../../types/dto/base-page-dto";

export const adminPageState = atom<BasePageDto<UserDto>>({
  key: "adminPageState",
  default: initPage,
});
